import { postEvent } from '../public'

export * from '../public/reducers/actions'
export * from './actionsSystem'

export const doLogin = ({ userName, password, ...rest } = {}) => {
	return postEvent({
		event: 'Login',
		data: { userName, password },
		...rest
	})
}

export const doAutoLogin = ({ ...rest } = {}) => {
	return postEvent({
		event: 'AutoLogin',
		data: {},
		...rest
	})
}

export const doGetLoginInfo = ({ ...rest } = {}) => {
	return postEvent({
		event: 'GetLoginInfo',
		data: {},
		...rest
	})
}


export const doGetLogin = ({ id, personID, ...rest } = {}) => {
	return postEvent({
		event: 'GetLogin',
		data: { id, personID, },
		...rest
	})
}

export const doSaveLogin = ({ id, personID, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveLogin',
		data: { id, personID, changedValues基本信息 },
		...rest
	})
}


export const doDeleteLogin = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteLogin',
		data: { id, },
		...rest
	})
}

export const doLogout = ({ ...rest } = {}) => {
	return postEvent({
		event: 'Logout',
		data: {},
		...rest
	})
}

export const doForgetPassword = ({ userName, resetEmail, ...rest } = {}) => {
	return postEvent({
		event: 'ForgetPassword',
		data: { userName, resetEmail },
		...rest
	})
}

export const doCheckToken = ({ token, ...rest } = {}) => {
	return postEvent({
		event: 'CheckToken',
		data: { token },
		...rest
	})
}

export const doSetPassword = ({ token, password, ...rest } = {}) => {
	return postEvent({
		event: 'SetPassword',
		data: { token, password },
		...rest
	})
}

export const doChangePassword = ({ oldPassword, newPassword, ...rest } = {}) => {
	return postEvent({
		event: 'ChangePassword',
		data: { oldPassword, newPassword },
		...rest
	})
}

export const doChangePasswordUnLogin = ({ oldPassword, newPassword, userName, ...rest } = {}) => {
	return postEvent({
		event: 'ChangePasswordUnLogin',
		data: { oldPassword, newPassword, userName },
		...rest
	})
}

export const doGetDashBoardData = ({ ...rest } = {}) => {
	return postEvent({
		event: 'GetDashboardData',
		data: {},
		...rest
	})
}

export const doDeleteContract = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteContract',
		data: { list },
		...rest
	})
}

export const doDeleteSample = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteSample',
		data: { list },
		...rest
	})
}

export const doSubmitRegisterContract = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'SubmitRegisterContract',
		data: { list },
		...rest
	})
}

export const doSubmitReceiveContract = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'SubmitReceiveContract',
		data: { list },
		...rest
	})
}

export const doSubmitCheckSample = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'SubmitCheckSample',
		data: { list },
		...rest
	})
}

export const doSubmitUploadSample = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'SubmitUploadSample',
		data: { list },
		...rest
	})
}

export const doSubmitAuditSample = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'SubmitAuditSample',
		data: { list },
		...rest
	})
}

export const doBackAuditSample = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'BackAuditSample',
		data: { list },
		...rest
	})
}



export const doGetBusinessPerson = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetBusinessPerson',
		data: { id },
		...rest
	})
}

export const doSaveBusinessPerson = ({ id, changedValues人员信息, changedValues人员角色, changedValues人员签名, ...rest } = {}) => {
	return postEvent({
		event: 'SaveBusinessPerson',
		data: { id, changedValues人员信息, changedValues人员角色, changedValues人员签名 },
		...rest
	})
}

export const doGetUploadFile = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetUploadFile',
		data: { id },
		...rest
	})
}

export const doSaveUploadFile = ({ id, changedValues整改报告附件, ...rest } = {}) => {
	return postEvent({
		event: 'SaveUploadFile',
		data: { id, changedValues整改报告附件 },
		...rest
	})
}

export const doGetResponseUploadFile = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetResponseUploadFile',
		data: { id },
		...rest
	})
}

export const doSaveResponseUploadFile = ({ id, changedValues回复报告附件, ...rest } = {}) => {
	return postEvent({
		event: 'SaveResponseUploadFile',
		data: { id, changedValues回复报告附件 },
		...rest
	})
}

export const doDelPerson = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DelPerson',
		data: { id, },
		...rest
	})
}



export const doGetSample = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetSample',
		data: { id },
		...rest
	})

}

export const doGetlistTestRequest = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetlistTestRequest',
		data: { id },
		...rest
	})
}

export const doGetReturnInventory = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetReturnInventory',
		data: { id },
		...rest
	})
}

export const doGetSummaryTable = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetSummaryTable',
		data: { id },
		...rest
	})
}

export const doGetScrapList = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetScrapList',
		data: { id },
		...rest
	})
}

export const doSaveSample = ({ id, changedValues基本信息, changedValues初步调查, changedValues解体一, changedValues解体二, changedValues委托试验, changedValues调查结论, ...rest } = {}) => {
	return postEvent({
		event: 'SaveSample',
		data: { id, changedValues基本信息, changedValues初步调查, changedValues解体一, changedValues解体二, changedValues委托试验, changedValues调查结论 },
		...rest
	})
}


export const doDelTestRequest = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DelTestRequest',
		data: { id },
		...rest
	})
}

export const doPreviousOne = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'PreviousOne',
		data: { id },
		...rest
	})
}

export const doNextOne = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'NextOne',
		data: { id },
		...rest
	})
}


export const doAddTestRequest = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'AddTestRequest',
		data: { id },
		...rest
	})
}

//新方法
export const doGetContract = ({ id, templetName, ...rest } = {}) => {
	return postEvent({
		event: 'GetContract',
		data: { id, templetName },
		...rest
	})
}

export const doSaveContract = ({ id, changedValues基本信息, templetName, ...rest } = {}) => {
	return postEvent({
		event: 'SaveContract',
		data: { id, changedValues基本信息, templetName },
		...rest
	})
}


export const doSaveGuage = ({ id, changedValues基本信息, contractid, ...rest } = {}) => {
	return postEvent({
		event: 'SaveGuage',
		data: { id, changedValues基本信息, contractid },
		...rest
	})
}

export const doGetGuage = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetGuage',
		data: { id },
		...rest
	})
}
export const doGetGaugeJson = ({ id, strReportName, ...rest } = {}) => {
	return postEvent({
		event: 'GetGaugeJson',
		data: { id, strReportName },
		...rest
	})
}

export const doSaveGaugeJson = ({ id, changedValues基本信息, strReportName, ...rest } = {}) => {
	return postEvent({
		event: 'SaveGaugeJson',
		data: { id, changedValues基本信息, strReportName },
		...rest
	})
}

export const doDeleteGauge = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteGauge',
		data: { id },
		...rest
	})
}

export const doContractFlow = ({ id, action, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'ContractFlow',
		data: { id, action, changedValues基本信息 },
		...rest
	})
}

export const doSampleFlow = ({ id, action, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SampleFlow',
		data: { id, action, changedValues基本信息 },
		...rest
	})
}

export const doGetGuageList = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'GetGuageList',
		data: { list },
		...rest
	})
}

export const doSearchGaugeList = ({ searchString, BusinessType, ...rest } = {}) => {
	return postEvent({
		event: 'SearchGaugeList',
		data: { searchString, BusinessType },
		...rest
	})
}

export const doSaveAndSubmitGaugeList = ({ list, changedValues量具信息, action, ...rest } = {}) => {
	return postEvent({
		event: 'SaveAndSubmitGaugeList',
		data: { list, changedValues量具信息, action },
		...rest
	})
}

export const doGetPersonByRoleName = ({ roleName, ...rest } = {}) => {
	return postEvent({
		event: 'GetPersonByRoleName',
		data: { roleName },
		...rest
	})
}

export const doGetPersonByGauge = ({ id, name, ...rest } = {}) => {
	return postEvent({
		event: 'GetPersonByGauge',
		data: { id, name },
		...rest
	})
}
export const doGetPersonByContract = ({ id, name, ...rest } = {}) => {
	return postEvent({
		event: 'GetPersonByContract',
		data: { id, name },
		...rest
	})
}
export const doGetStoreLocationFullName = ({ ...rest } = {}) => {
	return postEvent({
		event: 'GetStoreLocationFullName',
		data: {},
		...rest
	})
}
export const doGetRotationGaugeNumber = ({ ...rest } = {}) => {
	return postEvent({
		event: 'GetGetRotationGaugeNumber',
		data: {},
		...rest
	})
}

export const doGetGaugeType = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetGaugeType',
		data: { id },
		...rest
	})
}

export const doSaveGaugeType = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveGaugeType',
		data: { id, changedValues基本信息 },
		...rest
	})
}

export const doDeleteGaugeType = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteGaugeType',
		data: { id },
		...rest
	})
}

export const doBatchSendEmail = ({ list, ...rest } = {}) => {
	return postEvent({
		event: 'BatchSendEmail',
		data: { list },
		...rest
	})
}
export const doGetSpecimen = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetSpecimen',
		data: { id },
		...rest
	})
}
export const doSaveSpecimen = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveSpecimen',
		data: { id, changedValues基本信息 },
		...rest
	})
}

export const doDeleteSpecimen = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteSpecimen',
		data: { id },
		...rest
	})
}
export const doSaveGaugeRotateChange = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveGaugeRotateChange',
		data: { id, changedValues基本信息 },
		...rest
	})
}

export const doCheckStore = ({ GaugeID, ...rest } = {}) => {
	return postEvent({
		event: 'CheckStore',
		data: { GaugeID },
		...rest
	})
}

export const doSaveStore = ({ id, 库位, ...rest } = {}) => {
	return postEvent({
		event: 'SaveStore',
		data: { id, 库位 },
		...rest
	})
}
export const doSaveGaugeAssignInfo = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveGaugeAssignInfo',
		data: { id, changedValues基本信息 },
		...rest
	})
}

export const doSaveGaugeDisposeInfo = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveGaugeDisposeInfo',
		data: { id, changedValues基本信息 },
		...rest
	})
}

export const doGetCabinetContentList = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetCabinetContentList',
		data: { id },
		...rest
	})
}

export const doGetReportInfo = ({ token, ...rest } = {}) => {
	return postEvent({
		event: 'GetReportInfo',
		data: { token },
		...rest
	})
}

export const doRotateCharge = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'RotateCharge',
		data: { id },
		...rest
	})
}


export const doReportOperation = ({ token, action, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'ReportOperation',
		data: { token, action, changedValues基本信息 },
		...rest
	})
}

export const doReportExport = ({ id, strReportName, ...rest } = {}) => {
	return postEvent({
		event: 'ReportExport',
		data: { id, strReportName },
		...rest
	})
}
export const doSearchUncontrolledMeasuringToolList = ({ searchString, UseDep, ...rest } = {}) => {
	return postEvent({
		event: 'SearchUncontrolledMeasuringToolList',
		data: { searchString, UseDep },
		...rest
	})
}

export const doGetUncontrolledMeasuringTool = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetUncontrolledMeasuringTool',
		data: { id },
		...rest
	})
}
export const doSaveUncontrolledMeasuringTool = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveUncontrolledMeasuringTool',
		data: { id, changedValues基本信息 },
		...rest
	})
}


export const doGetEducationalMaterials = ({ id, personID, ...rest } = {}) => {
	return postEvent({
		event: 'GetEducationalMaterials',
		data: { id, personID, },
		...rest
	})
}

export const doSaveEducationalMaterials = ({ id, personID, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveEducationalMaterials',
		data: { id, personID, changedValues基本信息, },
		...rest
	})
}

export const doDeleteEducationalMaterials = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteEducationalMaterials',
		data: { id, },
		...rest
	})
}

export const doGetExternalExperience = ({ id, personID, ...rest } = {}) => {
	return postEvent({
		event: 'GetExternalExperience',
		data: { id, personID, },
		...rest
	})
}

export const doSaveExternalExperience = ({ id, personID, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveExternalExperience',
		data: { id, personID, changedValues基本信息, },
		...rest
	})
}

export const doDeleteExternalExperience = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteExternalExperience',
		data: { id, },
		...rest
	})
}


export const doGetInternalExperience = ({ id, personID, type, ...rest } = {}) => {
	return postEvent({
		event: 'GetInternalExperience',
		data: { id, personID, type, },
		...rest
	})
}

export const doSaveInternalExperience = ({ id, personID, type, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveInternalExperience',
		data: { id, personID, type, changedValues基本信息, },
		...rest
	})
}

export const doDeleteInternalExperience = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteInternalExperience',
		data: { id, },
		...rest
	})
}
// 出勤记录

export const doGetAttendanceRecord = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetAttendanceRecord',
		data: { id },
		...rest
	})
}

// 忘刷卡申请
export const doGetForgetSwipeCardApply = ({ id, checkRecordID, date, taskName, ...rest } = {}) => {
	return postEvent({
		event: 'GetForgetSwipeCardApply',
		data: { id, checkRecordID, date, taskName },
		...rest
	})
}

export const doSaveForgetSwipeCardApply = ({ id, checkRecordID, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveForgetSwipeCardApply',
		data: { id, checkRecordID, changedValues基本信息, },
		...rest
	})
}

export const doDeleteForgetSwipeCardApply = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteForgetSwipeCardApply',
		data: { id, },
		...rest
	})
}

export const doForgetSwipeCardApplyFlow = ({ id, action, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'ForgetSwipeCardApplyFlow',
		data: { id, action, changedValues基本信息 },
		...rest
	})
}

// 加班申请
export const doGetOverTimeApply = ({ id, taskName, ...rest } = {}) => {
	return postEvent({
		event: 'GetOverTimeApply',
		data: { id, taskName },
		...rest
	})
}

export const doGetHours = ({ startDate, endDate, personName, ...rest } = {}) => {
	return postEvent({
		event: 'GetHours',
		data: { startDate, endDate, personName },
		...rest
	})
}

export const doSaveOverTimeApply = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveOverTimeApply',
		data: { id, changedValues基本信息, },
		...rest
	})
}

export const doDeleteOverTimeApply = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteOverTimeApply',
		data: { id, },
		...rest
	})
}

export const doOverTimeApplyFlow = ({ id, action, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'OverTimeApplyFlow',
		data: { id, action, changedValues基本信息 },
		...rest
	})
}

// 假期管理
export const doGetHoliday = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetHoliday',
		data: { id },
		...rest
	})
}

export const doSaveHoliday = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveHoliday',
		data: { id, changedValues基本信息, },
		...rest
	})
}

// 给假管理
export const doGetGiveVacationApply = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetGiveVacationApply',
		data: { id },
		...rest
	})
}

export const doSaveGiveVacationApply = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveGiveVacationApply',
		data: { id, changedValues基本信息 },
		...rest
	})
}

// 系统节假日管理
export const doGetSysHoliday = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetSysHoliday',
		data: { id },
		...rest
	})
}

export const doSaveSysHoliday = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveSysHoliday',
		data: { id, changedValues基本信息, },
		...rest
	})
}


export const doDeleteSysHoliday = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteSysHoliday',
		data: { id },
		...rest
	})
}

// 请假管理
export const doGetLeaveApply = ({ id, checkRecordID, taskName, ...rest } = {}) => {
	return postEvent({
		event: 'GetLeaveApply',
		data: { id, checkRecordID, taskName },
		...rest
	})
}

export const doSaveLeaveApply = ({ id, checkRecordID, changedValues基本信息, changedValues出差事由, ...rest } = {}) => {
	return postEvent({
		event: 'SaveLeaveApply',
		data: { id, checkRecordID, changedValues基本信息, changedValues出差事由, },
		...rest
	})
}


export const doDeleteLeaveApply = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteLeaveApply',
		data: { id, },
		...rest
	})
}

export const doLeaveApplyFlow = ({ id, action, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'LeaveApplyFlow',
		data: { id, action, changedValues基本信息 },
		...rest
	})
}

export const doGetDriverInfo = ({ ...rest } = {}) => {
	return postEvent({
		event: 'GetDriverInfo',
		data: {},
		...rest
	})
}


// 薪资管理
export const doGetSalaryInfo = ({ id, taskName, ...rest } = {}) => {
	return postEvent({
		event: 'GetSalaryInfo',
		data: { id, taskName },
		...rest
	})
}

export const doSaveSalaryInfo = ({ id, list薪资明细, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveSalaryInfo',
		data: { id, list薪资明细, changedValues基本信息, },
		...rest
	})
}

export const doDeleteSalaryInfo = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteSalaryInfo',
		data: { id },
		...rest
	})
}

export const doSalaryInfoFlow = ({ id, action, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SalaryInfoFlow',
		data: { id, action, changedValues基本信息 },
		...rest
	})
}
// 月薪申请
export const doCreateSalaryApply = ({ changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'CreateSalaryApply',
		data: { changedValues基本信息 },
		...rest
	})
}

export const doGetMonthlySalaryApply = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetMonthlySalaryApply',
		data: { id, },
		...rest
	})
}

export const doRecalculation = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'Recalculation',
		data: { id, },
		...rest
	})
}

export const doGetMonthlySalaryDeduction = ({ id, taskName, ...rest } = {}) => {
	return postEvent({
		event: 'GetMonthlySalaryDeduction',
		data: { id, taskName },
		...rest
	})
}


export const doSaveMonthlySalaryDeduction = ({ id, list加扣项明细, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveMonthlySalaryDeduction',
		data: { id, list加扣项明细, changedValues基本信息 },
		...rest
	})
}

export const doRelease = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'Release',
		data: { id },
		...rest
	})
}

export const doConfirmObjectionDeduction = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'ConfirmObjectionDeduction',
		data: { id, changedValues基本信息 },
		...rest
	})
}

export const doGetBonusApplication = ({ id, taskName, ...rest } = {}) => {
	return postEvent({
		event: 'GetBonusApplication',
		data: { id, taskName },
		...rest
	})
}

export const doSaveBonusApplication = ({ id, 奖金期号, list奖金明细, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveBonusApplication',
		data: { id, 奖金期号, list奖金明细, changedValues基本信息 },
		...rest
	})
}


export const doDeleteBonusApplication = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteBonusApplication',
		data: { id },
		...rest
	})
}


export const doGetSalaryChangeLogInfo = ({ subjectName, personID, ...rest } = {}) => {
	return postEvent({
		event: 'GetSalaryChangeLogInfo',
		data: {
			subjectName,
			personID,
		},
		...rest
	})
}

export const doExportBonus = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'ExportBonus',
		data: {
			id
		},
		...rest
	})
}

export const doExportSalary = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'ExportSalary',
		data: {
			id
		},
		...rest
	})
}

// 导入

export const doImportBasic = ({ FID, ...rest } = {}) => {
	return postEvent({
		event: 'ImportBasic',
		data: { FID },
		...rest
	})
}

export const doImportinSideIn = ({ FID, ...rest } = {}) => {
	return postEvent({
		event: 'ImportinSideIn',
		data: { FID },
		...rest
	})
}

export const doImportinSideCh = ({ FID, ...rest } = {}) => {
	return postEvent({
		event: 'ImportinSideCh',
		data: { FID },
		...rest
	})
}

export const doImportCommunication = ({ FID, ...rest } = {}) => {
	return postEvent({
		event: 'ImportCommunication',
		data: { FID },
		...rest
	})
}

export const doImportExternal = ({ FID, ...rest } = {}) => {
	return postEvent({
		event: 'ImportExternal',
		data: { FID },
		...rest
	})
}

export const doImportEducation = ({ FID, ...rest } = {}) => {
	return postEvent({
		event: 'ImportEducation',
		data: { FID },
		...rest
	})
}

export const doImportVacationBalance = ({ FID, ...rest } = {}) => {
	return postEvent({
		event: 'ImportVacationBalance',
		data: { FID },
		...rest
	})
}

// 手机签核
export const doGetAllTaskList = (params = {}) => {
	const { title, id, type, ...rest } = params
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetAllTaskList',
			data: { title, id, type }
		},
		...rest
	})
}

export const doSubmitTask = (params = {}) => {
	const { task, comment, result, ...rest } = params
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'SubmitTask',
			data: {
				taskID: task.id,
				comment,
				result,
				title: task.title,
			},
		},
		...rest,
	})
}

export const doGetLimsUrl = (params = {}) => {
	const { result, ...rest } = params
	return postEvent({
		event: 'GetLimsUrl',
		data: {},
		...rest,
	})
}

export const doGetAllSignedTaskList = (params = {}) => {
	const { title, id, type, ...rest } = params
	return postEvent({
		event: 'GetAllSignedTaskList',
		data: { title, id, type },
		...rest
	})
}

export const doGetAllSignedApplyTaskList = (params = {}) => {
	const { title, id, type, ...rest } = params
	return postEvent({
		event: 'GetAllSignedApplyTaskList',
		data: { title, id, type },
		...rest
	})
}
